/**
 * RecoverCann Shared Cart Fetch
 *
 * Several independent modules (validation, quick shop, product cards) each
 * need a fresh /cart.js read and each retry on failure. Loaded separately,
 * they used to run their own retry loop, so a single "add to cart" could
 * fire off a burst of near-simultaneous /cart.js requests — the kind of
 * traffic pattern that trips Shopify's bot/rate-limit protection. This
 * gives every caller one shared in-flight request instead: concurrent
 * callers await the same promise rather than starting their own fetch.
 *
 * Must load before any script that calls window.RecoverCannFetchCart().
 */
(function () {
  'use strict';

  var CART_FETCH_RETRY_DELAYS_MS = [0, 120, 300];
  var inFlight = null;

  function attemptFetch() {
    return (async function () {
      var lastError = null;

      for (var i = 0; i < CART_FETCH_RETRY_DELAYS_MS.length; i++) {
        var delayMs = CART_FETCH_RETRY_DELAYS_MS[i];
        if (delayMs > 0) {
          await new Promise(function (resolve) { setTimeout(resolve, delayMs); });
        }

        try {
          var response = await fetch('/cart.js', {
            cache: 'no-store',
            headers: {
              'Cache-Control': 'no-cache',
              Pragma: 'no-cache',
            },
          });

          if (!response.ok) {
            lastError = new Error('Cart fetch failed (' + response.status + ')');
            continue;
          }

          return await response.json();
        } catch (error) {
          lastError = error;
        }
      }

      throw lastError || new Error('Cart fetch failed');
    })();
  }

  window.RecoverCannFetchCart = function fetchFreshCartShared() {
    if (inFlight) return inFlight;

    inFlight = attemptFetch().finally(function () {
      inFlight = null;
    });

    return inFlight;
  };
})();
